// extracted by mini-css-extract-plugin
module.exports = {"root":"StickyBox_root__3g4YE","left":"StickyBox_left__2LadX","right":"StickyBox_right__30xC5"};